import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyleSheet } from 'react-native';
import { TopGainersLosersType } from './types';
import { useMemo } from 'react';
import { Button, Col, Row } from '../../atoms';
import { NoDataPlaceholder } from '../../molecules';
import { AmountAvg, AmountChangePercent, AmountPrice, CurrencyIdentity, Tabs, Table, } from '../../organisms';
import { createColumnHelper } from '@tanstack/react-table';
import { theme } from '@xbto/design-system';
import { useBreakpoints } from '../../hooks';
export default function ComponentWeb({ rowData, onToggleType, onExploreMarkets, onRowPressed, }) {
    const { breakpoints } = useBreakpoints(500);
    /**
     * DOM
     */
    const tabs = useMemo(() => {
        return [
            { key: TopGainersLosersType.gainers, title: 'Top gainers' },
            { key: TopGainersLosersType.losers, title: 'Top losers' },
        ];
    }, []);
    const columnHelper = createColumnHelper();
    const columns = [
        columnHelper.accessor('code', {
            cell: ({ row }) => {
                const { code, displayCode, name } = row.original;
                return (_jsx(CurrencyIdentity, { code: code, displayCode: displayCode, name: name }));
            },
            size: 424,
            header: 'Asset',
            meta: { justify: 'flex-start', autoWidth: true },
        }),
        columnHelper.accessor('data.cryptoMarketDetail.price', {
            cell: info => {
                return _jsx(AmountPrice, { color: "primary", value: info.getValue() });
            },
            size: 148,
            header: 'Price',
            meta: { justify: 'flex-end' },
        }),
        columnHelper.accessor('data.cryptoMarketDetail.marketCap', {
            cell: info => {
                const value = info.getValue();
                if (!value) {
                    return _jsx(NoDataPlaceholder, {});
                }
                return _jsx(AmountAvg, { color: "primary", value: value });
            },
            size: 148,
            header: 'Market Cap',
            meta: { justify: 'flex-end' },
        }),
        columnHelper.accessor('data.cryptoMarketDetail.volume24h', {
            cell: info => {
                const value = info.getValue();
                if (!value) {
                    return _jsx(NoDataPlaceholder, {});
                }
                return _jsx(AmountAvg, { color: "primary", value: value });
            },
            size: 148,
            header: '24H Volume',
            meta: { justify: 'flex-end' },
        }),
        columnHelper.accessor('data.cryptoMarketDetail.change24hPercent', {
            cell: info => {
                return _jsx(AmountChangePercent, { value: info.getValue() });
            },
            size: 108,
            header: '24H',
            meta: { justify: 'flex-end' },
        }),
        /**
         * Note:
         * Design has 2 more columns for which we do not have data and that is fine for first deliverable as BE does not support it
         * And after discussing with Augusto came to a conclusion that the 2 columns do not add value
         */
    ];
    const panels = [
        _jsx(Col, { style: $.tableContainer, children: _jsx(Table, { data: rowData || [], columns: columns, onRowPressed: onRowPressed }) }, "gainers"),
        _jsx(Col, { style: $.tableContainer, children: _jsx(Table, { data: rowData || [], columns: columns, onRowPressed: onRowPressed }) }, "losers"),
    ];
    const exploreMarketButton = (_jsx(Button, { variant: "tertiary", label: "Explore markets", size: "sm", fullWidth: breakpoints.XS, onPress: onExploreMarkets }));
    return (_jsxs(Col, { children: [_jsx(Tabs, { panels: panels, tabs: tabs, tabStyle: "switcher", tabsRightAddOn: breakpoints.XS ? undefined : exploreMarketButton, fullWidth: true, tabsFullWidth: breakpoints.XS, onTabChange: v => onToggleType(v) }), breakpoints.XS && _jsx(Row, { mt: "4", children: exploreMarketButton })] }));
}
const $ = StyleSheet.create({
    tableContainer: {
        marginTop: theme.spacing[4],
    },
});
